import { useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import {
  FacebookShareButton,
  RedditShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

import {
  facebookWhiteIcon,
  linkCopyIcon,
  twitterWhiteIcon,
  whatsappWhiteIcon,
  redditWhiteIcon,
} from "assets/icons";

import { BlueCheckIcon } from "assets/icons";
import { Title } from "style/components/Title.styles";
import { userDetailSelect } from "Layout/slice/selector";
import { ReferralModalContainer } from "./ReferralModal.styles";

const ReferralModal = ({ onHide }) => {
  const [isCopied, setIsCopied] = useState(false);

  const profileDetails = useSelector(userDetailSelect);

  const socialShareText = `Hey there!

I just signed up for Surmount AI and I think it's a game changer for automated investing. 
  
If you're interested, I'd be grateful if you'd use my referral link to sign up: ${profileDetails?.referral_link}

You'll get a special offer!

Thanks in advance for considering it.`;

  const handleCopyClick = () => {
    navigator.clipboard.writeText(socialShareText);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <ReferralModalContainer onHide={onHide}>
      <Title>Invite your friends for exclusive perks</Title>

      <div className="link-wrapper">
        <div className="link"> {profileDetails?.referral_link} </div>
        <div
          className={classNames("icon", {
            copied: isCopied,
          })}
          onClick={handleCopyClick}
        >
          {isCopied ? (
            <BlueCheckIcon
              stroke="white"
              fill="none"
              height={22}
              width={22}
              viewBox="0 0 20 20"
            />
          ) : (
            <img src={linkCopyIcon} />
          )}
        </div>
      </div>

      <div className="social-media">
        <div className="title">Share with</div>

        <div className="social-media-icons">
          <div className="icon-wrapper">
            <FacebookShareButton url={profileDetails?.referral_link}>
              <img src={facebookWhiteIcon} />
            </FacebookShareButton>
          </div>
          <div className="icon-wrapper">
            <TwitterShareButton url={socialShareText}>
              <img src={twitterWhiteIcon} />
            </TwitterShareButton>
          </div>
          <div className="icon-wrapper">
            <WhatsappShareButton url={socialShareText}>
              <img src={whatsappWhiteIcon} />
            </WhatsappShareButton>
          </div>
          <div className="icon-wrapper">
            <RedditShareButton url={socialShareText}>
              <img src={redditWhiteIcon} />
            </RedditShareButton>
          </div>
        </div>
      </div>
    </ReferralModalContainer>
  );
};

export { ReferralModal };

ReferralModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
};
